<template>
  <div class="row mt-3">
    <div class="col"></div>
    <div class="col-lg-7">
      <table class="table">
        <thead>
          <tr>
            <th></th>
            <th></th>
            <th>{{ T.tableHeaderMonthly[lang] }}</th>
            <th>{{ T.tableHeaderYearly[lang] }}</th>
          </tr>
        </thead>
        <tbody id="adoTable">
          <tr v-for="row in rows" v-bind:key="row.title">
            <td v-bind:style="row.style"></td>
            <th>{{ row.title }}</th>
            <td class="text-right">{{ format.format(row.value) }}</td>
            <td class="text-right">{{ format.format(row.value*12) }}</td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td>&sum;</td>
            <th>{{ T.totalCost[lang] }}:</th>
            <td class="text-right">{{ format.format(sum) }}</td>
            <td class="text-right">{{ format.format(sum*12) }}</td>
          </tr>
          <tr>
            <td></td>
            <th>{{ T.szjaOnePercent[lang] }}</th>
            <td></td>
            <td class="text-right">{{ format.format(Math.round(rows[SZJA_INDEX].value*12*0.01)) }}</td>
          </tr>
        </tfoot>
      </table>
    </div>
    <div class="col"></div>
  </div>
</template>

<script>
import { getDataDesc, CURR_FORMAT, SZJA_INDEX } from "../js/main.js";
import { T } from '../js/translations';

export default {
  props: {
    taxes: {
      type: Object,
      required: true
    },
    year: {
      type: Number,
      required: true
    },
    lang: String
  },
  data: function() {
    return {
      format: CURR_FORMAT,
      SZJA_INDEX: SZJA_INDEX,
      T: T
    };
  },
  computed: {
    rows: function() {
      var ret = [];
      var DATA_DESC = getDataDesc(this.year, this.lang);
      for (var i = 0; i < DATA_DESC.length; i++) {
        var val = this.taxes[DATA_DESC[i][0]];
        ret.push({
          value: val,
          title: DATA_DESC[i][1],
          style: {
            background: DATA_DESC[i][2]
          }
        });
      }
      return ret;
    },
    sum: function() {
      var sum = 0;
      for (var i = 0; i < this.rows.length; i++) {
        sum += this.rows[i].value;
      }
      return sum;
    }
  }
};
</script>



// WEBPACK FOOTER //
// TaxTable.vue?5b8c8c20